import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  // Dummy user data
  const DUMMY_USER = {
    username: "admin@kenrui.ai",
    password: "Kadmin#1234",
  };

  const login = async (username, password) => {
    setLoading(true);
    setError(null);

    try {
      // 🔐 Dummy Login Check
      if (
        username === DUMMY_USER.username &&
        password === DUMMY_USER.password
      ) {
        const response = {
          accessToken: "dummy_access_token_123",
          refreshToken: "dummy_refresh_token_456",
          firstLogin: false,
          dateCreated: new Date().toISOString(),
        };

        // Save tokens
        localStorage.setItem("accessToken", response.accessToken);
        localStorage.setItem("refreshToken", response.refreshToken);
        localStorage.setItem("loginData", JSON.stringify(response));

        // ✅ Save login flag for protected routes
        sessionStorage.setItem("isLoggedIn", true);

        setData(response);

        // Redirect to dashboard
        navigate("/dashboard", { replace: true });

        return response;
      } else {
        throw new Error("Invalid Username or Password");
      }
    } catch (error) {
      setError(error.message);

      // Clear old tokens and login flag
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("loginData");
      sessionStorage.removeItem("isLoggedIn");

      return null;
    } finally {
      setLoading(false);
    }
  };

  return { login, loading, error, data };
};

export default useLogin;
